<template>
  <div style="display: flex;margin-bottom: 60px;">
    <div>
      <personalMenu :activeIndex="'6'"/>
    </div>
    <div class="creditRating">
      <div>

        <div class="title-div">
          <img style=" position: absolute;height: 115px;width: 75px;right: 0"
               src="http://yiyong-pub.oss-cn-shanghai.aliyuncs.com/ygw_web/personalCenter/xinyong_img_medal@2x.png">
          <div style="padding: 15px">
            <el-col :span="10">
              <div>
                <span style="padding-bottom: 30px">信用分 </span>

                <span style="font-size: 30px;font-weight: bold;color: #096CEF;vertical-align: -12%;">{{
                    userScoresInfo.score
                  }}分</span>
              </div>
            </el-col>
            <el-col :span="10">
              <span>信用等级 </span>
              <span v-if="userScoresInfo.creditStar.socreLevel == 0" style="padding-left: 10px"> 信用未评级</span>
              <i v-else v-for="item in userScoresInfo.creditStar.starCount"
                 style="font-size: 35px; color: #FFBB00FF;vertical-align: -15%;" class="el-icon-star-on"></i>
            </el-col>

            <el-progress style="padding-right:40px;" color="#FFC347FF" :show-text="true"
                         :percentage="userScoresInfo.rate * 100"></el-progress>

            <div>{{ userScoresInfo.scoreDetail }}</div>
          </div>
        </div>

        <div style="font-weight: bold; padding: 15px 0">积分详情</div>

        <div style="text-align: center">

          <el-row gutter="10">
            <el-col :span="8">
              <div style="background: #F9F9F9;border-radius: 6px;padding: 15px">
                <div>评价分</div>
                <div style="padding: 10px 0;font-size: 32px">{{ userScoresInfo.assessScore }}分</div>
                <div>
                  <i style="font-size: 35px; color: #DCDFE6" v-if="userScoresInfo.assessCreditStar.starCount==0"
                     class="el-icon-star-on"></i>
                  <i v-else v-for="item in userScoresInfo.assessCreditStar.starCount"
                     style="font-size: 35px; color: #FFBB00FF"
                     class="el-icon-star-on"></i>
                </div>
                <div style="padding: 10px 0;">
                  每50分一颗星，最多三颗星，你最近的项目评价分为{{ userScoresInfo.assessScore }}分，得
                  <span v-if="userScoresInfo.assessScore < 50">零</span>
                  <span v-else-if="(100 > userScoresInfo.assessScore) && (userScoresInfo.assessScore >= 50)">一</span>
                  <span v-else-if="(150 > userScoresInfo.assessScore) && (userScoresInfo.assessScore >= 100)">两</span>
                  <span v-else-if="userScoresInfo.assessScore >= 150">三</span>
                  颗星
                </div>
                <a style="color: #096CEFFF" @click="assessScoreShow=true">规则详情<i class="el-icon-arrow-right"></i></a>
              </div>
            </el-col>

            <el-col :span="8">
              <div style="background: #F9F9F9;border-radius: 6px;padding: 15px">
                <div>基本分</div>
                <div style="padding: 10px 0;font-size: 32px">{{ userScoresInfo.baseScore }}分</div>
                <div>
                  <i style="font-size: 35px; color: #DCDFE6" v-if="userScoresInfo.baseCreditStar.starCount==0"
                     class="el-icon-star-on"></i>
                  <i v-else v-for="item in userScoresInfo.baseCreditStar.starCount"
                     style="font-size: 35px; color: #FFBB00FF"
                     class="el-icon-star-on"></i>
                </div>
                <div style="padding: 10px 0;">完善我的资料获取积分，最多50分，得一颗星</div>
                <a style="color: #096CEFFF"
                   @click="baseScoreShow = true">规则详情<i
                  class="el-icon-arrow-right"></i></a>
                <!--                <a v-if="userScoresInfo.baseScore>=50" style="color: #096CEFFF" @click="baseScoreShow = true">规则详情<i-->
                <!--                  class="el-icon-arrow-right"></i></a>-->
                <!--                <a v-else style="color: #096CEFFF">去完善<i class="el-icon-arrow-right"></i></a>-->
              </div>
            </el-col>

            <el-col :span="8">
              <div style="background: #F9F9F9;border-radius: 6px;padding: 15px">
                <div>活跃分</div>
                <div style="padding: 10px 0;font-size: 32px">{{ userScoresInfo.activeScore }}分</div>
                <div>
                  <i style="font-size: 35px; color: #DCDFE6" v-if="userScoresInfo.activeCreditStar.starCount==0"
                     class="el-icon-star-on"></i>
                  <i v-else v-for="item in userScoresInfo.activeCreditStar.starCount"
                     style="font-size: 35px; color: #FFBB00FF"
                     class="el-icon-star-on"></i>
                </div>
                <div style="padding: 10px 0;">最近七天内有三天登录即可获得50积分，得一颗星</div>
                <a style="color: #096CEFFF" @click="activeScoreShow = true">规则详情<i class="el-icon-arrow-right"></i></a>
              </div>
            </el-col>

          </el-row>

        </div>

        <div v-if="list.length > 0" style="font-weight: bold; padding: 15px 0">项目评价</div>

        <div v-if="list.length > 0">

          <div v-for="(item, index) in list" :key="index"
               style="background: #F9F9F9;border-radius: 6px; padding: 15px;margin-bottom: 10px">
            <div>
              <el-col :span="20">
                <div>{{ item.projectName }}</div>
                <div style="margin: 10px 0;"><i class="el-icon-time"></i> {{ item.winTime }}</div>
              </el-col>
              <el-col class="evaluate" :span="4" style="text-align: right">
                <div class="you" v-if="item.assessGrades == 1"><span>优</span></div>
                <div class="liang" v-else-if="item.assessGrades == 2"><span>良</span></div>
                <div class="zhong" v-else-if="item.assessGrades == 3"><span>中</span></div>
                <div class="cha" v-else-if="item.assessGrades == 4"><span>差</span></div>
              </el-col>

              <div style="height: 60px;width: 100%;text-align: right"></div>
              <div v-if="item.scoreAssessMidList.length > 0"
                   style="width: 100%;text-align: right">
                <a v-if="item.showMore" @click="hideMore(index)">收起中期评价<i class="el-icon-arrow-up"></i></a>
                <a v-else @click="showMore(index)">查看中期评价<i class="el-icon-arrow-down"></i></a>
              </div>

              <div v-if="item.showMore">

                <div style="margin-top: 20px">
                  <el-col :span="8" v-for="data in item.scoreAssessMidList">
                    评价时间： {{ data.midTime }}
                    <span class="mid-grade">
                        <span v-if="data.midGrade == 1">优</span>
                        <span v-if="data.midGrade == 2">良</span>
                        <span v-if="data.midGrade == 3">中</span>
                        <span v-if="data.midGrade == 4">差</span>
                      </span>
                  </el-col>
                </div>
                <div style="color: #FFFFFF">.</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <el-dialog
        title="评价分详情"
        :visible.sync="assessScoreShow"
        width="30%"
        center>
        <span style="font-size: 16px">{{ userScoresInfo.assessScoreDetail }}</span>
      </el-dialog>

      <el-dialog
        title="基本分详情"
        :visible.sync="baseScoreShow"
        width="30%"
        center>
        <span style="font-size: 16px">{{ userScoresInfo.baseScoreDetail }}</span>
      </el-dialog>

      <el-dialog
        title="活跃分详情"
        :visible.sync="activeScoreShow"
        width="30%"
        center>
        <span style="font-size: 16px">{{ userScoresInfo.activeScoreDetail }}</span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  getScores,
  getScoreDetails
} from '@api/creditRating'
import personalMenu from "@views/layout/components/personalMenu";

export default {
  name: 'creditRating',
  components: {
    personalMenu
  },
  data() {
    return {
      userScoresInfo: {},
      assessScoreShow: false,
      baseScoreShow: false,
      activeScoreShow: false,
      list: []
    }
  },
  created() {
    this.getScores()
    this.getScoreDetails()
  },
  mounted() {
  },
  methods: {

    showMore(index) {
      this.list[index].showMore = true
      this.$forceUpdate()
    },

    hideMore(index) {
      this.list[index].showMore = false
      this.$forceUpdate()
    },

    getScores() {
      getScores().then(res => {
        if (res.data.code == 200) {
          this.userScoresInfo = res.data.data
        }
      })
    },

    getScoreDetails() {
      getScoreDetails({
        pageNum: 1,
        pageSize: 1000
      }).then(res => {
        if (res.data.code === 200) {
          this.list = res.data.data.rows
          this.list.map(item => {
            if (item.scoreAssessMidList.length > 0) {
              item.showMore = 0
            }
          })
        }
      });
    },
  }
}
</script>

<style lang="scss">

.el-progress-bar__outer {
  background-color: #FFECD1FF;
}

.el-progress__text {
  display: none;
}

.el-progress-bar {
  padding: 35px 40px 20px 0px;
}

.evaluate {
  span {
    font-size: 25px;
    padding: 10px 12px;
    border-radius: 50%;
    background-color: #FFFFFF;
  }

  .you {
    margin-top: 10px;
    color: #FFC561FF;
  }

  .liang {
    margin-top: 10px;
    color: #dfbb9f;
  }

  .zhong {
    margin-top: 10px;
    color: #9ca7b8;
  }

  .cha {
    margin-top: 10px;
    color: #a9c5e5;
  }
}

.creditRating {
  border-radius: 5px;
  padding: 20px;
  margin-left: 10px;
  width: 990px;
  margin-top: 20px;
  background-color: #FFFFFF;
  box-shadow: 0px 0px 20px #e6e6e6;

  .mid-grade {
    margin-left: 15px;
    color: #37A1FFFF;
  }

  .title-div {
    position: relative;
    width: 100%;
    background: #EFF6FF;
    border-radius: 6px 6px 6px 6px;
    //padding: 15px;
  }
}

</style>
